import { Card } from '@optools/components/ui/card';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@optools/components/ui/collapsible';
import {
  ScheduleContent,
  SchedulePipeline,
} from '@optools/services/operator-gateway/types/schedule';
import { ChevronUp } from 'lucide-react';

import { AuditMediaDetail } from './audit-media-detail';

export interface AuditPipelineDetailProps {
  content: Record<string, ScheduleContent>;
  pipeline: SchedulePipeline;
}

export function AuditPipelineDetail({ content, pipeline }: AuditPipelineDetailProps) {
  return (
    <Card className="p-4" data-testid={`game-pipeline-${pipeline.id}`}>
      <div className="mb-4 grid grid-cols-[40px_80px_96px_120px_160px] items-center gap-8">
        {/* ID */}
        <div className="flex flex-col gap-2 text-sm">
          <h2 className="font-bold">ID</h2>
          <p className="text-xs">{pipeline.id}</p>
        </div>

        {/* Feed Type */}
        <div className="flex flex-col gap-2 text-sm">
          <h2 className="font-bold">Feed Type</h2>
          <p className="text-xs">{pipeline.feedType}</p>
        </div>

        {/* Status */}
        <div className="flex flex-col gap-1 text-sm">
          <h2 className="font-bold">Status</h2>
          <p className="text-xs">{pipeline.status}</p>
        </div>

        {/* Stream State */}
        <div className="flex flex-col gap-1 text-sm">
          <h2 className="font-bold">Stream State</h2>
          <p>{pipeline.streamState}</p>
        </div>

        {/* Program Source */}
        <div className="flex flex-col gap-1 text-sm">
          <h2 className="font-bold">Program Source</h2>
          <p>{pipeline.programSource}</p>
        </div>
      </div>

      <Collapsible
        className="w-full overflow-x-auto rounded border bg-secondary p-2 pl-3"
        data-testid={`game-pipeline-${pipeline.id}-media`}>
        <CollapsibleTrigger className="group flex w-full items-center justify-between gap-8">
          <h2>Media</h2>
          <ChevronUp className="transition-transform group-data-[state='closed']:rotate-180" />
        </CollapsibleTrigger>

        <CollapsibleContent>
          <ul className="space-y-1 pt-2">
            {pipeline.media.map((mediaItem) => {
              return (
                <li key={mediaItem.id}>
                  <AuditMediaDetail content={content[mediaItem.id]} media={mediaItem} />
                </li>
              );
            })}
          </ul>
        </CollapsibleContent>
      </Collapsible>
    </Card>
  );
}
